export enum ExactClientEventStatus {
    declared = 'declared',
    failure = 'failure',
    started = 'started',
    success = 'success',
}
